export class CallLimiting {
  constructor(
    private readonly callsLimited: boolean | null,
    private readonly maxCallsPerBucket: number | null,
    private readonly maxCallsTotal: number | null,
    private readonly numCallsKept: number | null,
    private readonly numCallsOverBucketLimit: number | null,
    private readonly numCallsOverTotalLimit: number | null,
    private readonly numCallsTotal: number | null,
    private readonly numBuckets: number | null,
    private readonly numFullBuckets: number | null
  ) {}

  getCallsLimited() {
    return this.callsLimited;
  }

  getMaxCallsPerBucket() {
    return this.maxCallsPerBucket;
  }

  getMaxCallsTotal() {
    return this.maxCallsTotal;
  }

  getNumCallsKept() {
    return this.numCallsKept;
  }

  getNumCallsOverBucketLimit() {
    return this.numCallsOverBucketLimit;
  }

  getNumCallsOverTotalLimit() {
    return this.numCallsOverTotalLimit;
  }

  getNumCallsTotal() {
    return this.numCallsTotal;
  }

  getNumBuckets() {
    return this.numBuckets;
  }

  getNumFullBuckets() {
    return this.numFullBuckets;
  }

  hasAllLimits() {
    return (
      this.getMaxCallsPerBucket() !== null &&
      this.getMaxCallsTotal() !== null &&
      this.getNumCallsKept() !== null &&
      this.getNumCallsOverBucketLimit() !== null &&
      this.getNumCallsOverTotalLimit() !== null &&
      this.getNumCallsTotal() !== null &&
      this.getNumBuckets() !== null &&
      this.getNumFullBuckets() !== null
    );
  }
}
